import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {AuthenticationService} from './core/services/authentication/authentication.service';
import {filter, map, mergeMap} from 'rxjs';
import * as Sentry from '@sentry/angular';
import * as feather from 'feather-icons'
import {TranslateService} from '@ngx-translate/core';
import {LightSwitchComponent} from './shared/components/light-switch/light-switch.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LightSwitchComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements  OnInit, AfterViewInit {
  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly titleService: Title,
    private readonly translate: TranslateService,
    private readonly authenticationService: AuthenticationService,
  ) {
    // The TranslationService is automatically initialized when injected
    // No need to manually initialize it here
  }

  ngOnInit(): void {
    document.documentElement.className = localStorage.getItem('fsbr-theme') || 'light';

    this.router.events
      .pipe(
        filter((event: any) => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const userInfo = this.authenticationService.userData;
        if (userInfo) {
          Sentry.setUser({
            id: userInfo.id,
            username: userInfo.preferredUsername,
            email: userInfo.email
          });
        }
        else {
          Sentry.setUser(null);
        }

        const title = data['title'];
        if (!title) {
          this.titleService.setTitle('Backoffice Fastshop');
          return;
        }

        this.translate.get(title).subscribe({
          next: (translation: string) => {
            this.titleService.setTitle(translation);
          },
          error: () => {
            this.titleService.setTitle(title);
          }
        });
      });
  }

  ngAfterViewInit(): void {
    feather.replace();
  }
}
